/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var k = require("lexical");

var u = new Map();

function v(a) {
  for (; null != a;) {
    if (a.nodeType === Node.TEXT_NODE) return a;
    a = a.firstChild;
  }

  return null;
}

function w(a) {
  var b = a.parentNode;
  if (null == b) throw Error("Should never happen");
  return [b, Array.from(b.childNodes).indexOf(a)];
}

function y(a) {
  var b = {};
  a = a.split(";");

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;

      if ("" !== c) {
        var _c$split = c.split(/:([^]+)/),
            _c$split2 = _slicedToArray(_c$split, 2),
            e = _c$split2[0],
            d = _c$split2[1];

        b[e.trim()] = d.trim();
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return b;
}

function z(a) {
  var b = u.get(a);
  void 0 === b && (b = y(a), u.set(a, b));
  return b;
}

function A(a) {
  var b = "";

  for (var c in a) {
    c && (b += "".concat(c, ": ").concat(a[c], ";"));
  }

  return b;
}

function B(a, b) {
  var c = z("getStyle" in a ? a.getStyle() : a.style);
  b = Object.entries(b).reduce(function (e, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        d = _ref2[0],
        f = _ref2[1];

    null === f ? delete e[d] : e[d] = f;
    return e;
  }, _objectSpread({}, c));
  c = A(b);
  a.setStyle(c);
  u.set(c, b);
}

function C(a, b) {
  var c = a.getNodes(),
      e = c.length;

  if (k.DEPRECATED_$isGridSelection(a)) {
    var d = k.$createRangeSelection(),
        f = d.anchor,
        h = d.focus;

    for (var g = 0; g < e; g++) {
      var l = c[g];
      k.DEPRECATED_$isGridCellNode(l) && (f.set(l.getKey(), 0, "element"), h.set(l.getKey(), l.getChildrenSize(), "element"), C(k.$normalizeSelection__EXPERIMENTAL(d), b));
    }

    k.$setSelection(a);
  } else if (--e, d = c[0], f = c[e], a.isCollapsed()) B(a, b);else {
    var m = a.anchor,
        p = a.focus;
    g = d.getTextContent().length;
    l = p.offset;
    var n = m.offset,
        r = m.isBefore(p);
    h = r ? n : l;
    a = r ? l : n;
    var q = r ? m.type : p.type,
        t = r ? p.type : m.type;
    m = r ? p.key : m.key;
    k.$isTextNode(d) && h === g && (p = d.getNextSibling(), k.$isTextNode(p) && (h = n = 0, d = p));
    if (1 === c.length) k.$isTextNode(d) && (h = "element" === q ? 0 : n > l ? l : n, a = "element" === t ? g : n > l ? n : l, h !== a && (0 === h && a === g ? (B(d, b), d.select(h, a)) : (c = d.splitText(h, a), c = 0 === h ? c[0] : c[1], B(c, b), c.select(0, a - h))));else for (k.$isTextNode(d) && h < d.getTextContentSize() && (0 !== h && (d = d.splitText(h)[1]), B(d, b)), k.$isTextNode(f) && (h = f.getTextContent().length, f.__key !== m && 0 !== a && (a = h), a !== h && (_f$splitText = f.splitText(a), _f$splitText2 = _slicedToArray(_f$splitText, 1), f = _f$splitText2[0], _f$splitText), 0 !== a && B(f, b)), a = 1; a < e; a++) {
      var _f$splitText, _f$splitText2;

      h = c[a], g = h.getKey(), k.$isTextNode(h) && g !== d.getKey() && g !== f.getKey() && !h.isToken() && B(h, b);
    }
  }
}

function D(a) {
  for (; null !== a && !k.$isRootOrShadowRoot(a);) {
    var b = a.getLatest(),
        c = a.getParent();
    0 === b.getChildrenSize() && a.remove(!0);
    a = c;
  }
}

function E(a, b, c, e) {
  var d = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  if (0 !== b.length) {
    var f = b[0],
        h = new Map(),
        g = [];
    f = k.$isElementNode(f) ? f : f.getParentOrThrow();
    f.isInline() && (f = f.getParentOrThrow());

    for (var l = !1; null !== f;) {
      var m = f.getPreviousSibling();

      if (null !== m) {
        f = m;
        l = !0;
        break;
      }

      f = f.getParentOrThrow();
      if (k.$isRootOrShadowRoot(f)) break;
    }

    m = new Set();

    for (var p = 0; p < c; p++) {
      var n = b[p];
      k.$isElementNode(n) && 0 === n.getChildrenSize() && m.add(n.getKey());
    }

    var r = new Set();

    for (p = 0; p < c; p++) {
      n = b[p];
      var q = n.getParent();
      null !== q && q.isInline() && (q = q.getParent());

      if (null !== q && k.$isLeafNode(n) && !r.has(n.getKey())) {
        if (n = q.getKey(), void 0 === h.get(n)) {
          (function () {
            var t = e();
            t.setFormat(q.getFormatType());
            t.setIndent(q.getIndent());
            g.push(t);
            h.set(n, t);
            q.getChildren().forEach(function (x) {
              t.append(x);
              r.add(x.getKey());
              k.$isElementNode(x) && x.getChildrenKeys().forEach(function (H) {
                return r.add(H);
              });
            });
            D(q);
          })();
        }
      } else m.has(n.getKey()) && (q = e(), q.setFormat(n.getFormatType()), q.setIndent(n.getIndent()), g.push(q), n.remove(!0));
    }

    if (null !== d) for (b = 0; b < g.length; b++) {
      d.append(g[b]);
    }
    b = null;
    if (k.$isRootOrShadowRoot(f)) {
      if (l) {
        if (null !== d) f.insertAfter(d);else for (d = g.length - 1; 0 <= d; d--) {
          f.insertAfter(g[d]);
        }
      } else if (l = f.getFirstChild(), k.$isElementNode(l) && (f = l), null === l) {
        if (d) f.append(d);else for (d = 0; d < g.length; d++) {
          l = g[d], f.append(l), b = l;
        }
      } else if (null !== d) l.insertBefore(d);else for (f = 0; f < g.length; f++) {
        d = g[f], l.insertBefore(d), b = d;
      }
    } else if (d) f.insertAfter(d);else for (d = g.length - 1; 0 <= d; d--) {
      l = g[d], f.insertAfter(l), b = l;
    }
    g = k.$getPreviousSelection();
    k.$isRangeSelection(g) && g.anchor.getNode().isAttached() && g.focus.getNode().isAttached() ? k.$setSelection(g.clone()) : null !== b ? b.selectEnd() : a.dirty = !0;
  }
}

function F(a, b, c, e) {
  a.modify(b ? "extend" : "move", c, e);
}

function G(a) {
  a = a.anchor.getNode();
  return "rtl" === (k.$isRootNode(a) ? a : a.getParentOrThrow()).getDirection();
}

exports.$addNodeStyle = function (a) {
  a = a.getStyle();
  var b = y(a);
  u.set(a, b);
};

exports.$cloneWithProperties = function (a) {
  var b = a.constructor.clone(a);
  b.__parent = a.__parent;
  b.__next = a.__next;
  b.__prev = a.__prev;
  if (k.$isElementNode(a) && k.$isElementNode(b)) return b.__first = a.__first, b.__last = a.__last, b.__size = a.__size, b.__format = a.__format, b.__indent = a.__indent, b.__dir = a.__dir, b;
  k.$isTextNode(a) && k.$isTextNode(b) && (b.__format = a.__format, b.__style = a.__style, b.__mode = a.__mode, b.__detail = a.__detail);
  return b;
};

exports.$getSelectionStyleValueForProperty = function (a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var e = null,
      d = a.getNodes();
  var f = a.anchor,
      h = a.focus,
      g = a.isBackward();
  var l = g ? h.offset : f.offset;
  f = g ? h.getNode() : f.getNode();
  if ("" !== a.style && (a = z(a.style), null !== a && b in a)) return a[b];

  for (a = 0; a < d.length; a++) {
    var m = d[a];
    if ((0 === a || 0 !== l || !m.is(f)) && k.$isTextNode(m)) if (h = b, g = c, m = m.getStyle(), m = z(m), h = null !== m ? m[h] || g : g, null === e) e = h;else if (e !== h) {
      e = "";
      break;
    }
  }

  return null === e ? c : e;
};

exports.$isAtNodeEnd = function (a) {
  return "text" === a.type ? a.offset === a.getNode().getTextContentSize() : a.offset === a.getNode().getChildrenSize();
};

exports.$isParentElementRTL = G;
exports.$moveCaretSelection = F;

exports.$moveCharacter = function (a, b, c) {
  var e = G(a);
  F(a, b, c ? !e : e, "character");
};

exports.$patchStyleText = C;

exports.$selectAll = function (a) {
  var b = a.anchor;
  a = a.focus;
  var c = b.getNode().getTopLevelElementOrThrow().getParentOrThrow();
  var e = c.getFirstDescendant();
  c = c.getLastDescendant();
  var d = "element",
      f = "element",
      h = 0;
  k.$isTextNode(e) ? d = "text" : k.$isElementNode(e) || null === e || (e = e.getParentOrThrow());
  k.$isTextNode(c) ? (f = "text", h = c.getTextContentSize()) : k.$isElementNode(c) || null === c || (c = c.getParentOrThrow());
  e && c && (b.set(e.getKey(), 0, d), a.set(c.getKey(), h, f));
};

exports.$setBlocksType = function (a, b) {
  if ("root" === a.anchor.key) {
    b = b();
    var c = k.$getRoot();
    (a = c.getFirstChild()) ? a.replace(b, !0) : c.append(b);
  } else for (c = a.getNodes(), a = a.anchor.getNode().getParentOrThrow(), -1 === c.indexOf(a) && c.push(a), a.isInline() && (a = a.getParentOrThrow(), -1 === c.indexOf(a) && c.push(a)), a = 0; a < c.length; a++) {
    var f = c[a];
    var e = f;
    if (!k.$isElementNode(e) || k.$isRootOrShadowRoot(e)) e = !1;else {
      var d = e.getFirstChild();
      d = null === d || k.$isLineBreakNode(d) || k.$isTextNode(d) || d.isInline();
      e = !e.isInline() && !1 !== e.canBeEmpty() && d;
    }
    e && (e = b(), e.setFormat(f.getFormatType()), e.setIndent(f.getIndent()), f.replace(e, !0));
  }
};

exports.$shouldOverrideDefaultCharacterSelection = function (a, b) {
  a = k.$getAdjacentNode(a.focus, b);
  return k.$isDecoratorNode(a) && !a.isIsolated() || k.$isElementNode(a) && !a.isInline() && !a.canBeEmpty();
};

exports.$sliceSelectedTextNodeContent = function (a, b) {
  if (b.isSelected() && !b.isSegmented() && !b.isToken() && (k.$isRangeSelection(a) || k.DEPRECATED_$isGridSelection(a))) {
    var c = a.anchor.getNode(),
        e = a.focus.getNode(),
        d = b.is(c),
        f = b.is(e);

    if (d || f) {
      d = a.isBackward();

      var _a$getCharacterOffset = a.getCharacterOffsets(),
          _a$getCharacterOffset2 = _slicedToArray(_a$getCharacterOffset, 2),
          h = _a$getCharacterOffset2[0],
          g = _a$getCharacterOffset2[1];

      a = c.is(e);
      f = b.is(d ? e : c);
      e = b.is(d ? c : e);
      c = 0;
      var l = void 0;
      a ? (c = h > g ? g : h, l = h > g ? h : g) : f ? (c = d ? g : h, l = void 0) : e && (d = d ? h : g, c = 0, l = d);
      b.__text = b.__text.slice(c, l);
    }
  }

  return b;
};

exports.$wrapNodes = function (a, b) {
  var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var e = a.getNodes();
  var d = e.length;
  var f = a.anchor;

  if (0 === d || 1 === d && "element" === f.type && 0 === f.getNode().getChildrenSize()) {
    a = "text" === f.type ? f.getNode().getParentOrThrow() : f.getNode();
    e = a.getChildren();
    var g = b();
    g.setFormat(a.getFormatType());
    g.setIndent(a.getIndent());
    e.forEach(function (l) {
      return g.append(l);
    });
    c && (g = c.append(g));
    a.replace(g);
  } else {
    f = null;
    var h = [];

    for (var _g = 0; _g < d; _g++) {
      var l = e[_g];
      k.$isRootOrShadowRoot(l) ? (E(a, h, h.length, b, c), h = [], f = l) : null === f || null !== f && k.$hasAncestor(l, f) ? h.push(l) : (E(a, h, h.length, b, c), h = [l]);
    }

    E(a, h, h.length, b, c);
  }
};

exports.createDOMRange = function (a, b, c, e, d) {
  var _w, _w2, _w3, _w4;

  var f = b.getKey(),
      h = e.getKey(),
      g = document.createRange(),
      l = a.getElementByKey(f);
  a = a.getElementByKey(h);
  k.$isTextNode(b) && (l = v(l));
  k.$isTextNode(e) && (a = v(a));
  if (void 0 === b || void 0 === e || null === l || null === a) return null;
  "BR" === l.nodeName && (_w = w(l), _w2 = _slicedToArray(_w, 2), l = _w2[0], c = _w2[1], _w);
  "BR" === a.nodeName && (_w3 = w(a), _w4 = _slicedToArray(_w3, 2), a = _w4[0], d = _w4[1], _w3);
  b = l.firstChild;
  l === a && null != b && "BR" === b.nodeName && 0 === c && 0 === d && (d = 1);

  try {
    g.setStart(l, c), g.setEnd(a, d);
  } catch (m) {
    return null;
  }

  !g.collapsed || c === d && f === h || (g.setStart(a, d), g.setEnd(l, c));
  return g;
};

exports.createRectsFromDOMRange = function (a, b) {
  var c = a.getRootElement();
  if (null === c) return [];
  a = c.getBoundingClientRect();
  c = getComputedStyle(c);
  c = parseFloat(c.paddingLeft) + parseFloat(c.paddingRight);
  b = Array.from(b.getClientRects());
  var e = b.length;
  b.sort(function (f, h) {
    var g = f.top - h.top;
    return 3 >= Math.abs(g) ? f.left - h.left : g;
  });
  var d;

  for (var f = 0; f < e; f++) {
    var h = b[f],
        g = h.width + c === a.width;
    d && d.top <= h.top && d.top + d.height > h.top && d.left + d.width > h.left || g ? (b.splice(f--, 1), e--) : d = h;
  }

  return b;
};

exports.getStyleObjectFromCSS = z;

exports.trimTextContentFromAnchor = function (a, b, c) {
  var e = b.getNode();

  if (k.$isElementNode(e)) {
    var d = e.getDescendantByIndex(b.offset);
    null !== d && (e = d);
  }

  for (; 0 < c && null !== e;) {
    var f = e.getPreviousSibling(),
        h = 0;

    if (null === f) {
      d = e.getParentOrThrow();

      for (var g = d.getPreviousSibling(); null === g;) {
        d = d.getParent();

        if (null === d) {
          f = null;
          break;
        }

        g = d.getPreviousSibling();
      }

      null !== d && (h = d.isInline() ? 0 : 2, f = k.$isElementNode(g) ? g.getLastDescendant() : g);
    }

    g = e.getTextContent();
    "" === g && k.$isElementNode(e) && !e.isInline() && (g = "\n\n");
    d = g.length;
    if (!k.$isTextNode(e) || c >= d) g = e.getParent(), e.remove(), null == g || 0 !== g.getChildrenSize() || k.$isRootNode(g) || g.remove(), c -= d + h, e = f;else {
      (function (_e$splitText, _e$splitText2, _e$splitText3, _e$splitText4) {
        var l = e.getKey();
        h = a.getEditorState().read(function () {
          var p = k.$getNodeByKey(l);
          return k.$isTextNode(p) && p.isSimpleText() ? p.getTextContent() : null;
        });
        f = d - c;
        var m = g.slice(0, f);
        null !== h && h !== g ? (c = k.$getPreviousSelection(), d = e, e.isSimpleText() ? e.setTextContent(h) : (d = k.$createTextNode(h), e.replace(d)), k.$isRangeSelection(c) && c.isCollapsed() && (c = c.anchor.offset, d.select(c, c))) : e.isSimpleText() ? (h = b.key === l, g = b.offset, g < c && (g = d), c = h ? g - c : 0, d = h ? g : f, h && 0 === c ? ((_e$splitText = e.splitText(c, d), _e$splitText2 = _slicedToArray(_e$splitText, 1), c = _e$splitText2[0], _e$splitText), c.remove()) : ((_e$splitText3 = e.splitText(c, d), _e$splitText4 = _slicedToArray(_e$splitText3, 2), c = _e$splitText4[1], _e$splitText3), c.remove())) : (c = k.$createTextNode(m), e.replace(c));
        c = 0;
      })();
    }
  }
};